import React from 'react';
import {Quill} from 'react-quill';

import ReactDOMServer from 'react-dom/server';

import {PencilRegularIcon} from '../icon/svg/pencil-regular-icon';

const Embed = Quill.import('blots/embed');

export type Placeholder = {
    id: string;
    label: string;
};

// Renders when adding a new placeholder text block
export class PlaceholderBlotCustomPlaceholder extends Embed {
    static blotName = 'placeholder-custom-placeholder';
    static tagName = 'span';
    static className = 'ql-placeholder-blot-custom-placeholder';

    placeholderValue: Placeholder | null | undefined;

    constructor(domNode: Node, value?: Placeholder) {
        super(domNode, value);
        this.placeholderValue = value;
    }

    static create(value: Placeholder) {
        const node: HTMLElement = super.create(value);
        node.setAttribute('data-id', value.id);
        node.setAttribute('data-label', value.label);
        node.setAttribute('spellcheck', 'false');

        const label = value.label;
        node.innerHTML = ReactDOMServer.renderToStaticMarkup(
            React.createElement(
                'span',
                {className: 'ql-placeholder-content'},
                React.createElement(PencilRegularIcon, {
                    size: 14,
                    wrapWithDiv: false,
                }),
                React.createElement('span', {}, label)
            )
        );

        return node;
    }

    value() {
        return '';
    }

    static value(domNode: HTMLElement) {
        return domNode.dataset;
    }

    length(): number {
        return 1;
    }
}
